import { ChangePasswordWidgetData } from './types';
import { NetworkRequestState } from '../baseTypes';

const defaultChangePasswordWidgetData: NonNullable<
  ChangePasswordWidgetData['initialData']
> = {
  currentPassword: '',
  newPassword: '',
  newPasswordRepeat: '',
};

export const defaultChangePasswordWidgetState: ChangePasswordWidgetData = {
  initialData: defaultChangePasswordWidgetData,
  currentData: defaultChangePasswordWidgetData,
  isDirty: false,
  saveRequest: {
    status: NetworkRequestState.IDLE,
  },
};
